
export const Urls = {
  // LOGIN_API: "/api/1/auth/login/",
  LOGIN_API: "/api/1/cus/smart-login",
  LOGOUT_API: "/api/1/cus/logout",
  LOGIN_REFRESH_API: "/api/1/auth/login/refresh/",
  USER_DETAIL_API: "/api/1/cus/auth/user/",
  USER_AUTH_PERMISSION_API: "/api/1/auth/user/permissions",
  USER_ACTIVITY: "/api/1/user-activity/",
  GET_CMS_PERMISSION_LIST_API: "/api/1/cms/permissions/",
  GET_CMS_CONTENT_TYPE: "/api/1/cms/content_type/",
  GET_CMS_GROUPS_LIST: "/api/1/cms/groups/",
  PUT_CMS_GROUP_PERMISSIONS: "/api/1/cms/groups/",
  GET_USER_LIST_API: "/api/1/users/",
  GET_USER_API: "/api/1/user/",
  GET_CMS_WEBINAR_LIST_API: "/api/1/cms/webinars/",
  PUT_CMS_WEBINAR_SPEAKERS_API: "/api/1/cms/webinar-speakers/",
  PUT_CMS_WEBINAR_URL_API: "/api/1/cms/webinar-urls/",
  GET_WEBINAR_FILTERS_API: "/api/1/webinars/filters",
  GET_CMS_SYNONYMS_LIST_API: "/api/1/cms/synonyms/",
  GET_CMS_NEWSLETTER_LIST_API: "/api/1/cms/campaigns/",
  GET_CMS_NEWSLETTER_CONTENT_CAMPAIGN_LIST_API:
    "/api/1/cms/campaigns/campaign-content/",
  GET_CMS_PRODUCT_PLAN_API: "/api/1/cms/plans/",
  GET_CMS_PRODUCT_PLAN_FEATURE_API:
    "/api/1/cms/sellable-product-group-feature/",
  GET_CMS_PRODUCTS_API: "api/1/cms/products/",
  GET_CMS_PRODUCT_TYPE_API: "/api/1/cms/product-types/",
  GET_CMS_PRODUCT_FEATURE_API: "/api/1/cms/features/",
  GET_CMS_MAP_PRODUCT_FEATURE_API: "/api/1/cms/product-feature/",
  GET_CMS_NEWSLETTER_ARTICLE_LIST_API: "/api/1/cms/campaigns/campaign-content/",
  GET_CMS_PRODUCT_LANDING_API: "/api/1/cms/landing-pages/",
  GET_CMS_SPG_LANDING_API: "/api/1/cms/landing-pages-spg/",
  GET_CMS_LANDING_PAGE_FAQ_API: "/api/1/cms/landing-pages-faq/",
  GET_CMS_LANDING_PAGE_BANNER_LIST: "/api/1/cms/landing-pages-banners/",
  GET_CMS_LANDING_PAGE_BANNER: "/api/1/cms/landing-pages-banner/",
  GET_CMS_USER_SELLABLE_PRODUCT_API: "/api/1/cms/user-sellable-products/",
  GET_CMS_SPG_FEATURE_API: "/api/1/cms/sellable-product-group-feature/",
  GET_CMS_FEATURE_KEYWORD_API: "/api/1/cms/feature-keywords/",
  DELETE_CMS_KEYWORD_SERVICE_API: "api/1/keyword-service/delete-keyword/",
  //SPG API
  GET_SPG_TYPE_LIST_API: "/api/1/cms/spg-type/",
  GET_MAPPED_ENTITY_LIST_API: "/api/1/cms/spg-mapped-entity-type/",
  GET_MAPPED_ENTITY_API: "api/1/cms/spg-mapped-entity/",
  GET_LEARN_MAPPED_ENTITY_API: "api/2/sellableproductgroup-list/",
  GET_AUTO_ACCESS_API: "/api/1/cms/spg-auto-access/",
  GET_SPG_INTEREST_API: "/api/1/cms/spg-interests/",
  GET_ADDITIONAL_MAPPING_FIELDS: "/api/1/cms/spg-mappings/",
  GET_ENTITY_VALIDATE_API: "/api/1/cms/spg-entity-validate",
  GET_SPG_LEVELS_API: "/api/1/cms/spg-levels",
  GET_MAP_PRODUCT_API: "/api/1/cms/products/spg/",
  GET_CMS_FEATURE_SYNONYMS_API: "/api/1/cms/feature-synonyms/",
  GET_CMS_USER_SELLABLE_PRODUCT_DETAIL_API: "/api/1/cms/user-sellable-product/",
  POST_CMS_USER_SELLABLE_PRODUCT_SPG_API:
    "/api/1/cms/user-sellable-products/update/",
  GET_SPG_LANDING_API: "/api/1/cms/landing-page-map-plans/",
  PUT_CMS_PAYMENT_DEATAILS_UPDATE_API: "/api/1/payment/update/",
  GET_PRODUCT_MAPPED_ENTITY_API: "/api/1/cms/products/mapped_entity",
  PUT_PRODUCT_SPG_MAPPING_API: "/api/1/cms/product-spg-mapping/",

  GET_ARTICLES: "/api/1/article/",
  GET_KEYWORDS: "/api/1/article/keywords",
  GET_WEBINAR_KEYWORDS: "api/1/webinar/keywords",
  GET_HEADER_API: "/api/1/header/",
  PUT_CMS_USER_PERMISSIONS: "/api/1/user/",

  GET_ARTICLE_AUDIO_API: "/api/1/article-audio/",
  GET_USER_FEED_GENERATION_API: "/api/1/user-feed-generate",

  GET_TOP_CATEGORIES: "/api/1/top-categories/",
  GET_LATEST_ARTICLE: "/api/1/articles/latest/",
  GET_WEBINAR_PAGE_DETAILS: "/api/1/webinars/",
  GET_HOMEPAGE_PLANS: "/api/1/homepage-plans/",

  GET_HOME_WEBINARS_LIST: "/api/1/webinars/",
  GET_LATEST_CATEGORY: "/api/1/premium-category/",
  GET_PLAN: "/api/1/plans/",
  POST_COUPON_VALIDITY: "/api/1/coupon/check-validity/",
  POST_PAYMENT_CREATE: "/api/1/payment/checkout/",
  GET_HOMPAGE_BANNER_API: "/api/1/homepage/",
  GET_FAQS: "/api/1/faqs/",
  GET_LANDING_PAGE_DETAIL: "/api/1/landing-page-detail/",
  GET_LANDING_SPG_DETAIL: "/api/1/landing-page-spg-detail/",
  GET_LANDING_PAGE_BANNER: "/api/1/landing-page-banner/",

  GET_LOCATIONS_API: "/api/1/locations/",
  GET_IDP_PERMISSION_CHECK_API: "/api/1/idp/permission-check/",
  GET_CONTENT_RECOMMENDATIONS_API:
    "/api/1/keyword-service/content-recommendation/",
  GET_USER_FEED: "/api/1/user/feed/",
  POST_USER_FEED: "/api/1/user/feed/",
  GET_USER_KEYWORDS: "/api/1/user/keywords/",
  POST_USER_KEYWORDS: "/api/1/user/keywords/",
  GET_USER_FEEDBACK: "/api/1/user/feedback/",
  POST_USER_FEEDBACK: "/api/1/user/feedback/",
  POST_CLEAR_ENTITY_CACHE: "/api/1/delete-entity-cache/",
  GET_CMS_FEATURE_GROUPS_LIST_API: "api/1/cms/feature-groups/",
  POST_CMS_FEATURE_GROUPS_API: "api/1/cms/feature-groups/",
  PUT_CMS_FEATURE_GROUPS_API: "api/1/cms/feature-groups/",
  POST_DOWNLOAD_PDF_API: "/api/1/article/download-pdf/",
  CHANGE_SPG_MAPPING_API: "/api/1/cms/spg-entity-mapping/",
  GET_CMS_SPG_LIST: "/api/1/cms/spg-entity-mapping-filter/",
  GET_PRODUCT_MAPPED_ENTITY: "/api/1/cms/products/mapped_entity",
  GET_PRODUCT_SELLEBLE_TYPE: "api/1/cms/products/sellable_type",
  GET_PRODUCT_MAPPED_ENTITY_CHECK: "/api/1/cms/products/mapped_entity_check",

  // Common urls
  GET_URL_CHECK_API: "/api/1/url-check",

  //College Detail Urls

  COLLEGE_OVERVIEW_ADMISSION_API: "/api/1/institution/institution-admission",
  COLLEGE_OVERVIEW_API: "/api/1/institution/institution-overview",
  COLLEGE_OVERVIEW_COURSES_API: "/api/1/institution/institution-courses",
  COLLEGE_OVERVIEW_FAQ_API: "api/1/institution/institution-faq",
  COLLEGE_OVERVIEW_ALUMNI_API: "/api/1/institution/institution-alumni",
  COLLEGE_ADMISSION_DETAIL_API: "/api/1/institution/institution-admission",
  COLLEGE_OVERVIEW_CERTIFICATION_API:
    "/api/1/institution/institution-certification",
  COLLEGE_OVERVIEW_REVIEWS_API:
    "/api/1/institution/institution-overview-review",
  COLLEGE_OVERVIEW_FACILITY_API:
    "/api/1/institution/institution-overview-facility",
  COLLEGE_OVERVIEW_GALLERY_API: "/api/1/institution/institution-gallery",
  COLLEGE_OVERVIEW_PLACEMENT: "/api/1/institution/placement-overview",
  COLLEGE_SCHOLARSHIP_DETAIL_API: "/api/1/institution/institution-scholarship",
  COLLEGE_REVIEW_DETAIL_API: "/api/1/institution/institution-detail-review",
  COLLEGE_EXAM_DETAIL_API: "/api/1/institution/institution-accepted-exam",
  COLLEGE_DIVERSITY_API: "/api/1/institution/institution-diversity",
  COLLEGE_OTHER_CAMPUSES_API: "/api/1/institution/institution-other-campus",
  COLLEGE_HEADER_DETAIL_API: "/api/1/institution/institution-header",
  COLLEGE_QNA_DETAIL_API: "/api/1/institution/institution-qna",
  COLLEGE_COMPARISON_API: "/api/1/institution/institution-college-compare",
  COLLEGE_COURSES_DETAIL_API: "/api/1/institution/course-list-api",
  COLLEGE_COURSES_CERTIFICATION_DETAIL_API:
    "/api/1/institution/institution-course-detail",
  COLLEGE_OVERVIEW_AFFILIATED_COLLEGES_API:
    "/api/1/institution/affilated-colleges",
  COLLEGE_BROWSE_BY_DEGREE_API: "api/1/institution/browse-by-degree",
  COLLEGE_TOP_RANKED_API: "/api/1/institution/institution-top-ranked",
  COLLEGE_COURSE_FILTERS_API: "/api/1/institution/course-listing-filters",
  COLLEGE_AFFILIATED_DETAIL_API:
    "/api/1/institution/institution-detail-affiliated",
  COLLEGE_AFFILIATED_FILTERS_API:
    "/api/1/institution/institution-filter-affiliated",
  COLLEGE_KNOW_MORE_ABOUT_API: "/api/1/institution/institution-know-more",
  COLLEGE_POPULAR_COURSES_API: "/api/1/institution/institution-popular-courses",
  COLLEGE_POPULAR_CERTIFICATION_API: "/api/1/institution/branch-certification",
  COLLEGE_ADMISSION_COURSES_API: "/api/1/institution/admission-college-courses",
  COLLEGE_PLACEMENT_DETAIL_API: "/api/1/institution/placement-detail",
  COLLEGE_POPULAR_COLLEGE_STATE_API:
    "api/1/institution/institution-popular-college-state",
  COLLEGE_OVERVIEW_RANKING_API:
    "api/1/institution/institution-ranking-overview",
  COLLEGE_VIEW_SIMILARCOLLEGE_API:
    "/api/1/institution/institution-interested-in",
  COLLEGE_OVERVIEW_RANKING_BUBBLE_GRAPH_API:
    "/api/1/institution/institution-ranking-overview-bubble-graph",
  COLLEGE_DETAIL_BREADCRUMP_API: "/api/1/institution/breadcrumb",
  COLLEGE_CUTOFF_DETAIL_API: "/api/1/institution/college-cutoff",
  COLLEGE_COURSE_LIST_CTA_API: "/api/1/institution/course-list-pdf",
  COLLEGE_PLACEMENT_REPORT_CTA_API: "/api/1/institution/placement-report-cta",
  COLLEGE_ADMISSION_DETAIL_CTA_API: "/api/1/institution/admission-details-pdf",
  COLLEGE_FEES_STRUCTURE_CTA_API: "/api/1/institution/fees-structure-pdf",
  COLLEGE_CERTIFICATION_DETAIL_CTA_API:
    "api/1/institution/certificate-detail-pdf",
  COLLEGE_AFFILIATED_COLLEGE_LIST_CTA_API: "api/1/institution/college-list-pdf",
  COLLEGE_KNOW_YOUR_CHANCES_CTA_API: "api/1/institution/know-your-chances-cta",
  COLLEGE_ROUNDWISE_CUTOFF_CTA_API: "api/1/institution/cutoff-mailer",
  COLLEGE_OVERVIEW_ACCREDATIONS_API:
    "api/1/institution/institution-accreditation-overview",
  COLLEGE_FAT_FOOTER_API: "api/1/institution/fat-footer",
  COLLEGE_CERTIFICATION_CTA_API:
    "api/1/institution/course-online-certificate-cta-redirection",
  COLLEGE_COURSES_RELATED_ARTICLES: "api/1/institution/course-detail-articles",
  COLLEGE_META_TAGS_API: "/api/1/institution/listing-seo-tags",
  COLLEGE_COURSE_DETAIL_FAT_FOOTER: "api/1/institution/fat-footer-static",
  GET_COLLEGE_REVIEW_FILTERS_API:
    "api/1/institution/institution-detail-review-filter",
  COLLEGE_COURSE_METATAGS_API:
    "/api/1/institution/institution-lisiting-course-meta",
  //College Listing Urls

  GET_COLLEGES_LIST_API: "/api/1/institution/listing",
  GET_COLLEGES_FILTERS_API: "/api/1/institution/filters",
  GET_COLLEGES_LISTING_FAQ_API: "/api/1/institution/listing/faq",
  GET_COLLEGES_LISTING_HEADER_API: "/api/1/institution/listing/header",
  GET_COLLEGES_SOURCE_API: "/api/1/institution/get-url-source",
  GET_COLLEGE_LISTING_OTHER_EXAMS_API: "/api/1/institution/other-exams",
  GET_COLLEGE_LISTING_SEO_TAGS_API: "/api/1/institution/listing-seo-tags",
  GET_COLLEGE_GALLERY_API: "api/1/institution/institution-gallery",
  GET_COURSE_LISTING_API: "api/1/institution/download-brochure-list",
  GET_BROCHURE_RECOMMENDED_COLLEGES_API:
    "api/1/institution/client-institute-download-brochure",
  GET_COLLEGE_BROCHURE_MAILER_API: "api/1/institution/download-brochure-mailer",
  GET_COLLEGE_ENQUIRE_MAILER_API: "api/1/institution/enquire-mailer",
  POST_COLLEGE_LISTING_BROCHURE_API:
    "api/1/institution/donwload-enquire-cta-update",
  GET_STATE_CITY_API: "api/1/institution/get-city-state",

  GET_ARTICLES_DETAIL_API: "/api/2/article/",
  GET_UPCOMIMG_EXAMS_API: "/api/1/entity/upcoming-exams",
  GET_NEWS_NOTIFICATION_API: "/api/1/entity/news/",
  GET_RELATED_E_BOOKS_API: "api/1/entity/ebooks/",
  GET_QNA_PWA_API: "api/1/entity/qna",
  GET_FOOTER_PWA_API: "/api/1/entity/section/",
  GET_ALSO_READ_API: "/api/1/entity/also-read/",
  GET_POPULAR_COURSES_SPECIALIZATION_API:
    "/api/1/entity/popular-courses-specialization/",
  GET_CERTIFICATE_ARTICLE_API: "/api/1/entity/certificate-article/",
  GET_NCERT_ARTICLE_API: "/api/1/entity/ncert-article/",
  GET_META_DATA_API: "/api/1/entity/meta-details/",
  GET_SUBMENU_API: "/api/1/submenu",
  GET_SUBMENU_COLLEGE_API: "/api/1/institution-exam-articles/submenu",
  GET_RELATED_ARTICLES_API: "/api/1/entity/related-article/",
  GET_POPULAR_COLLEGES_API: "/api/1/entity/popular-colleges/",
  GET_UPDATES_API: "/api/1/get-updates/",
  GET_POPULAR_COLLEGES_NCERT_API: "/api/1/entity/popular-colleges-12/",
  GET_PRODUCT_MAPPING_API: "/api/1/product-mapping/",
  GET_BREADCRUMBS_PWA_API: "/api/1/breadcrumbs/",
  GET_POPULAR_COLLEGES_LOCATION_API: "/api/1/entity/popular-college-locations/",
  GET_EXPLORE_CAREER_OPTIONS_API: "/api/1/entity/popular-industries/",
  GET_NCERT_QUESTION_API: "/api/1/previous-year-questions/",
  GET_COURSE_PROVIDERS_API: "/api/1/entity/popular-colleges-certificate/",
  GET_TRENDING_SEARCH_API: "/api/1/entity/trending-search/",
  GET_FAT_FOOTER_API: "/api/1/fat-footer-api/",
  POST_DOWNLOAD_BROCHURE_API: "/exam-get-update",
  GET_BROCHURE_DOWNLOAD_LIST_API: "/api/1/institution/download-brochure-list/",
  GET_BROCHURE_DOWNLOAD_FROM_LIST_API: "/api/1/institution/download-brochure/",
  POST_ASK_NOW_QNA_API: "/api/1/qna-ask-question/",
  GET_CLIENT_INSTITUTE_LIST_BROCHURE_API:
    "/api/1/institution/client-institute-download-brochure",
  REDIRECT_URL: "/api/1/url-redirection/",
  GET_DOWNLAOD_PDF_API: "/ajax/article-pdf-to-user-mail",
  GET_HOME_PAGE_DATA_SEO: "/api/1/seo-landing-page-spg-detail",
  GET_SCHOOL_RESOURCE_COUNT_API: "/api/1/school/resource-count",
  GET_SCHOOL_EBOOKS_API: "/api/1/school/ebooks/",
  GET_SCHOOL_LATEST_NEWS_API: "/api/1/school/latest-news/",
  GET_SCHOOL_PREMIUM_API: "/api/1/landing-page-spg-detail/",
  GET_SCHOOL_CAREERS_QNA_API: "/api/1/school/qna/",
  GET_SCHOOL_METADATA_API: "/api/1/entity/meta-details/",
  GET_SCHOOL_LATEST_READ: "api/1/school/latest-read/",
  GET_SCHOOL_LEARN_QNA_API: "/api/2/qna-questions/",

  // School Detail Api's
  GET_SCHOOL_DETAIL_API: "/api/1/school/school-detail",
  GET_SCHOOL_ACADEMICS: "/api/1/school/school-academics",
  GET_SCHOOL_ALSO_READ: "/api/1/entity/also-read",
  GET_SCHOOL_FEE_DETAILS: "/api/1/school/fee-details",
  GET_SCHOOL_IMPORTANT_DATE: "/api/1/school/important-dates",
  GET_SCHOOL_FACILITIES: "/api/1/school/school-facilities",
  GET_SCHOOL_SIMILAR: "/api/1/school/similar-schools",
  GET_SCHOOL_RESULTS: "/api/1/school/school-results",
  GET_SCHOOL_ALL_CLASS: "/api/1/school/school-classes",
  GET_SCHOOL_BOARDS: "/api/1/school/school-fees-boards",
  GET_SCHOOL_CLASS_CURRENT: "/api/1/school/school-fees-classes",
  GET_SCHOOL_APPLY: "/api/1/school/school-apply-now",
  POST_SCHOOL_DETAIL_CTA_API: "/api/1/school/school-cta",

  //CMS Coaching APIs
  GET_CMS_COACHING_LIST: "/api/1/cms/coaching-list",
  GET_CMS_COACHING_COURSES: "/api/1/cms/coaching-courses",
  GET_CMS_COACHING_EXAMS: "/api/1/cms/coaching-exams",
  GET_CMS_COACHING_SUBJECTS: "/api/1/cms/coaching-subjects",
  GET_CMS_COACHING_COURSE_LIST: "/api/1/cms/coaching-course-list",
  POST_CMS_COACHING_OVERVIEW_API: "/api/1/cms/add-coaching",
  GET_CMS_COACHING_LOCATION: "/api/1/cms/cms-location",
  PATCH_CMS_COACHING_OVERVIEW: "/api/1/cms/add-coaching/update/",
  GET_CMS_COACHING_MEDIA_DROPDOWN_API: "/api/1/cms/media-type",
  UPDATE_CMS_COACHING_MEDIA_API: "/api/1/cms/add-media/update/",
  GET_CMS_COACHING_MEDIA_API: "/api/1/cms/coaching-media",
  // UPDATE_CMS_COACHING_COURSE_API: "/api/1/cms/add-coaching-course/update/",
  UPDATE_CMS_COACHING_COURSE_API: "/api/1/cms/post-coaching-course",
  POST_CMS_COACHING_TOPPER_API: "/api/1/cms/add-topper",
  PATCH_CMS_COACHING_TOPPER_API: "/api/1/cms/add-topper/update/",
  GET_COACHING_NAME_API: "/api/1/cms/get-coaching-name",
  POST_COACHING_COURSE_API: "/api/1/cms/post-coaching-course",
  GET_COACHING_TOPPERS_API: "api/1/cms/coaching-toppers",
  GET_COACHING_INSTITUTE_API: "api/1/cms/coaching_institute",
  POST_COACHING_INSTITUTE_API: "/api/1/cms/add-coaching-institute",
  UPDATE_COACHING_INSTITUTE_API: "/api/1/cms/add-coaching-institute/update/",
  GET_COACHING_DISTRICT_LIST_API: "/api/1/cms/district",
  DELETE_COACHING_OTHER_MEDIA_API: "/api/1/cms/delete-media",
  POST_COACHING_MEDIA_IMAGE_API: "/api/1/cms/other-media-file-upload",
  POST_COACHING_COURSE_PUBLISH_API: "api/1/cms/coaching-published",
  POST_COACHING_PUBLISH_API: "api/1/cms/coaching-published",

  // CMS COUNTRY APIs
  GET_CMS_COUNTRY_LIST: "/api/v1/cms/countries",
  GET_CMS_COUNTRY_OVERVIEW: "/api/v1/cms/countries/overview",
  GET_CMS_COUNTRY_LANGUAGES: "/api/vi/cms/countries/country-languages",
  GET_CMS_COUNTRY_POPULAR_PLACES: "/api/v1/cms/countries/popularplace",
  GET_CMS_COUNTRY_BASIC_DETAILS: "/api/v1/cms/countries/basic-detail",
  GET_CMS_COUNTRY_CONTENT_DETAILS: "/api/v1/cms/countries/content-detail",
  GET_CMS_COUNTRY_FAQS: "/api/v1/cms/countries/faq",
  GET_CMS_COUNTRY_MEDIA: "/api/v1/cms/countries/media",

  // CMS REGISTRATION APIs
  GET_CMS_DEGREE_GROUPINNG: "/api/1/cus/degree-grouping-panel",
  POST_CMS_DEGREE_GROUPING: "/api/1/cus/degree-grouping-panel",
  GET_CMS_MESSAGING_SEARCH: "/api/1/cus/search-content",
  GET_CMS_MESSAGING_CONTENT: "api/1/cus/manage-content",
  POST_CMS_MESSAGING_CONTENT: "api/1/cus/manage-content/",
  PUT_CMS_MESSAGING_CONTENT: "api/1/cus/manage-content/",
  GET_CMS_ACCOUNT_DELETE: "api/1/cms/account-delete",
  POST_CMS_ACCOUNT_DELETE: "api/1/cms/account-delete",
  POST_CMS_USER_LOGOUT: "/api/1/cus/cms-user-logout",
  CMS_GOOGLE_FLOW: "/api/1/cms/manage-google",
  // URL Creation Panel of Registration
  URL_CREATION_API:"/api/1/cms/registration/url-creation/",
  ONE_CLICK_LOGIN_URL_CREATION_API: "api/1/cms/registration/oneclick-login/",



  //USER Block APIs
  GET_CMS_BLOCK_USERS: "/api/1/cus/block-users",
  GET_CMS_SEARCH_USERS: "/api/1/cus/search-users",
  POST_CMS_BLOCK_USERS: "/api/1/cus/block-users/",
  GET_CMS_STAFF_REGISTER: "/api/1/cus/staff-reg",
  POST_LOG_OUT_API: "api/1/cus/cms-user-logout",

  // CMS DOMAIN APIS
  GET_CMS_DOMAIN_LIST: "/api/1/cms/blocked-mail-domain",

  // USER CONTACT PUSH
  GET_CUP_CONTACT_USER_LIST_API: "/api/1/leads/contact-push-upload",
  POST_CUP_SEND_TO_NETCORE_API: "/api/1/leads/send-to-netcore/",
  POST_CUP_CONTACT_USER_PUSH_API: "/api/1/leads/contact-push-upload",
  GET_CUP_SEND_TO_NETCORE_API: "/api/1/leads/send-to-netcore/",

  // HIRING PANEL APIs
  GET_POST_JOB_LISTING_API: "/api/1/cms/job-listing",
  GET_DEPARTMENTS_API: "api/1/cms/department",
  GET_USERS_LIST_API: "/api/1/cms/user-list",
  GET_PUT_JOB_BASIC_DETAIL_API: "/api/1/cms/job-basic-detail",
  EDIT_STATIC_CONTENT_API: "/api/1/cms/edit-static-content",
  GET_JOB_LOCATION_API: "/api/1/cms/location",
  GET_APPLICANT_LIST_API: "/api/1/cms/applicant-list",
  GET_APPLICANT_FILTERS_API: "/api/1/cms/applicant-filters",
  GET_APPLICANT_API: '/api/1/cms/applicant',
  GET_DOWNLOAD_APPLICANT_LIST_API: '/api/1/cms/download-applicants',
  GET_FLUSH_APPLICANT_DATA: "/api/1/cms/applicant/data-flush",
  // VIDEO PANEL
  GET_VIDEO_LISTING_API: "/api/1/cms/videos",
  GET_VIDEO_FILTER_API: "/api/1/cms/videos-filter",
  // Static Pages
  GET_POST_STATIC_CONTENT_API: "/api/1/cms/static-contents/",
  //MANAGE RANKING COLLEGE PANEL
  GET_COLLEGE_RANKING_FILTER_API: "/api/1/cms/study-abroad/ranking-filter",
  GET_COLLEGE_RANKING_LIST: "/api/1/cms/study-abroad/college-ranking-list",
  POST_COLLEGE_RANKING_LIST: "/api/1/cms/study-abroad/college-ranking-list",
  GET_STUDYABROAD_COLLEGE_RANKING_DETAIL:"/api/1/cms/study-abroad/college-ranking-detail",
  PUT_COLLEGE_RANKING_DETAIL_UPDATE:"/api/1/cms/study-abroad/college-ranking-detail",
  GET_COLLEGE_RANKING_FILTER_COLLEGE:"/api/1/cms/study-abroad/college-ranking-exist",
  //MANAGE RANKING COURSE PANEL
  GET_COURSE_RANKING_LIST:"/api/1/cms/study-abroad/course-ranking-list",
  GET_COURSE_RANKING_DETAIL:"/api/1/cms/study-abroad/course-ranking-detail",
  GET_COURSE_RANKING_FILTER_COURSES: "/api/1/cms/study-abroad/course-ranking-exist",

  // CP FEEDBACK PANEL
  GET_FEEDBACK_FILTER_API: "/api/v1/cms/college-predictor/feedback-filter",
  GET_FEEDBACK_LISTING_API: "/api/v1/cms/college-predictor/feedback-list",
  GET_FEEDBACK_DETAIL_API: "/api/v1/cms/college-predictor/feedback-detail",
  PUT_FEEDBACK_MAPPED_STATUS_API: "/api/1/cms/college-predictor/feedback/mapped-status/",
  // AUTHOR PROFILE
  GET_AUTHOR_PROFILE_API: "/api/1/cms/author-profile",
  GET_AUTHOR_PROFILE_FILTER_API: "/api/1/cms/author-profile/filter",
  // Clevertap Delete Profile API
  POST_CLEVERTAP_DELETE_PROFILE: "/1/delete/profiles.json",
  // Learn user logut api
  POST_LEARN_USER_LOGOUT: "/api/2/user-profile-careers-update/",

  // ARTICLE FOR APP
  GET_APPS_ARTICLE_LIST_API: "/api/1/cms/article-list",
  GET_APPS_ARTICLE_FILTER_API: "/api/1/cms/article-filter",
  GET_APPS_ARTICLE_DETAIL_API: "/api/1/cms/article/",
  POST_APPS_ARTICLE_IMAGE_API: "/api/1/cms/upload-image/",

  // Manage RP APIs
  GET_COMMON_DROPDOWN_API: "api/1/cms/rp/common-dropdown",
  CUSTOM_MEAN_API: "api/1/cms/rp/custom-mean-sd",
  GET_INPUT_FORM_LIST_API: "api/1/cms/rp/input-form-list",
  GET_DETAIL_INPUT_API: "api/1/cms/rp/flow-type",
  CREATE_FORM_API: "api/1/cms/rp/create-input-form",
  CREATE_FORM_DETAIL_API:"api/1/cms/rp/create-form",
  MANAGE_EXAM_SESSION_API: "api/1/cms/rp/exam-session",
  VARIATION_FCTOR_API: "api/1/cms/rp/variation-factor",
  MANAGE_IO_FLOW_TYPE_API:"api/1/cms/rp/flow-type",
  APPEARED_STUDENTS_API: "api/1/cms/rp/appeared-student",
  RP_MERIT_LIST_API:"api/1/cms/rp/merit-list",
  MERIT_LIST_VALIDATION_CHECK_API:"api/1/cms/rp/merit-list-validation-check",
  UPLOAD_MERIT_LIST_API:"api/1/cms/rp/upload-merit-list",
  RP_USAGE_LIST_API:"api/1/cms/rp/rp-usage-list",
  RP_USAGE_ANALYTICS_API:"api/1/cms/rp/rp-usage-analytics",
  // manage predictor tools filter api
  GET_MANAGE_PREDICTOR_TOOLS_FILTER_API:"/api/1/cms/manage-tool/filter",
  GET_MANAGE_PREDICTOR_TOOLS_FILTER_Listing_API:"/api/1/cms/manage-tool/list",
  GET_MANAGE_PREDICTOR_TOOLS_BASIC_DETAIL_DROPDOWNLIST:"/api/1/cms/rp/common-dropdown",
  GET_MANAGE_PREDICTOR_TOOLS_BASIC_DETAIL_API:"/api/1/cms/manage-tool/basic-detail?product_id=",
  POST_BASIC_DETAILS_API:"/api/1/cms/manage-tool/basic-detail?product_id=",
  MANAGE_PREDICTOR_TOOLS_BASIC_DETAIL_API:"api/1/cms/manage-tool/basic-detail",

  // manage predictor input detail page
  GET_PREDICTOR_INPUT_PAGE_DETAIL:"/api/1/cms/manage-tool/input-page-detail",
  GET_PREDICTOR_INPUT_PAGE_TOOL_CONTENT:"/api/1/cms/manage-tool/tool-content",
  GET_PREDICTOR_INPUT_PAGE_FAQ:"api/1/cms/manage-tool/faq",

  GET_PREDICTOR_MANAGE_RESULT_PAGE:"api/1/cms/manage-tool/manage-result-page",
  // FAQ PANELS API's
  // ARTICLE FAQ PANEL
  GET_FAQ_ARTICLE_FILTER_API: "/api/1/cms/faq/article-filter",
  GET_FAQ_ARTICLE_LIST_API: "/api/1/cms/faq/article-list",
   // COLLEGE DETAIL FAQ PANEL
   FAQ_COLLEGE_FILTER_API: '/api/1/cms/faq/college-filter',
   FAQ_COLLEGE_LIST_API: '/api/1/cms/faq/college-list',
  // COLLEGE FACET & RANKING FAQ PANEL
  FAQ_COLLEGE_FACET_FILTER_API: '/api/1/cms/faq/facet-filter',
  FAQ_COLLEGE_FACET_LIST_API: '/api/1/cms/faq/cms-college-facet-ranking',
  // EXAM FAQ PANEL
  FAQ_EXAM_FILTER_API: '/api/1/cms/faq/exam-filter',
  FAQ_EXAM_LIST_API: '/api/1/cms/faq/exam-list',
  // FAQ COMMON GNERATION API
  FAQ_GENERATE_COMMON_API: '/api/1/cms/faq/generate-faq-common',
  // FAQ ADD/EDIT COMMON 
  GET_FAQ_EDIT_PAGE_COMMON_API: "/api/1/cms/faq/edit-page-common",
  GET_FAQ_QUESTION_KEYWORDS_API: "/api/1/cms/faq/questioin-keywords-filter",
  // FAQ DELETE API
  DELETE_QUESTION_AND_MAPPING_API: "/api/1/cms/faq/question-and-mapping-delete",
  // FAQ ENTITIY LOCK API
  FAQ_ENTITY_LOCK_API: '/api/1/cms/faq/cms-entity-lock',
  // CLEAR CACHE
  POST_CLEAR_CACHE:'api/1/common-cdn-invalidate',

  //WEB-STORIES
  GET_WEB_STORY_FILTER_API : "/api/1/cms/webstory/keyword-map/filter",
  GET_WEB_STORY_LIST_API: "/api/1/cms/webstory/keyword-map/listing",
  GET_WEB_STORY_ADD_EDIT_API: "api/1/cms/webstory/keyword-map",
  GET_WEB_STORY_ENTITY_FILTER_API: "api/1/cms/webstory/filter-map",
  
  // Poll management
  GET_POllS_FILTER_API:"api/1/cms/polls/filters",
  GET_POllS_LIST_API:"api/1/cms/polls/listing",
  POLLS_API:'api/1/cms/polls',

  //COMMENT MODERATION
  GET_COMMENT_MODERATION_FILTER_API:"/api/1/cms/polls/search",
  GET_COMMENT_MODERATION_LIST_API:"/api/1/cms/polls/comments",

  //MANAGE PRODUCT DIALER
  GET_CMS_PRODUCT_LIST_API: "/api/1/cms/product-list/",
  POST_CMS_PRODUCT_LIST_API: "/api/1/cms/product/push-to-dialer-update",

  //DEGREE ORDERING
  CMS_DEGREE_ORDERING :"/api/1/cms/order-degree/",

  // WA URL Mapping Panel CMS
  GET_DOMAIN_MAPPING_FILTER_API: "/api/1/cms/whatsapp/get-filter/",
  GET_DOMAIN_MAPPING_LIST_API:"/api/1/cms/whatsapp/mappings/",
  DOMAIN_MAPPING_API:'/api/1/cms/whatsapp/mappings/',

};

export const BASE_URL = process.env.REACT_APP_API_URL;
